import React from 'react';
import { Grid } from '@mui/system';
import { Button } from '@mui/material';

function ScheduleAppointment({ scheduleSection }) {
  const scrollHandler = () => {
    const section = document.getElementsByClassName('contact-form-section-wrap')[0];
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  };
  return (

    <div
      className="scheduleAppointment-section-wrap"
      style={{ backgroundImage: `url(${scheduleSection?.backgroundImage?.url})` }}
    >
      <Grid
        container
        sx={{ justifyContent: 'space-between', alignItems: 'center' }}
    >
        <Grid size={{ xs: 12, sm: 8 }}>
          <div className="title">{scheduleSection?.title}</div>
          <div className="subTitle">{scheduleSection?.subTitle}</div>
        </Grid>
        <Grid
          mt={{ sm: 0, xs: 4 }}
          container
          size={{ xs: 12, sm: 4 }}
          sx={{
            justifyContent: { sx: 'start', sm: 'end' },
            gap: '24px',
          }}
      >

          <Button
            size="large"
            variant={scheduleSection?.bookButton?.variant || 'contained'}
            onClick={scrollHandler}
            >
            {scheduleSection?.bookButton?.label?.slice(0, 25)}
          </Button>

          <Button
            size="large"
            variant={scheduleSection?.enquireButton?.variant || 'outlined'}
            onClick={scrollHandler}
            >
            {scheduleSection?.enquireButton?.label?.slice(0, 25)}
          </Button>
        </Grid>
      </Grid>
    </div>

  );
}

export default ScheduleAppointment;
